import React from 'react'
import i18n from 'support/i18n'

const LoadMoreButton = ({ onClick, classes }) => (
  <div className={classes.loadMoreWrapper}>
    <button type='button' className={classes.loadmorebtn || classes.viewlink} onClick={onClick}>
      {i18n.t('HOME.FILTER.LOAD_MORE')}
    </button>
  </div>
)

export default LoadMoreButton
